import React from "react";
import UnitConfigurationListPageContainer from "./UnitConfigurationListPageContainer";

export class UnitConfigurationListPage extends React.Component {
  render() {
    return <UnitConfigurationListPageContainer {...this.props} />;
  }
}
